import { put, takeLatest } from 'redux-saga/effects'
import * as actions from './slices'
import { blockHostReq, getBlockedHostListReq, getHostListReq } from '../../../api/host'

export function* getHostListApi() {
  yield put(actions.setIsLoading(true))
  try {
    const { data } = yield getHostListReq()
    yield put(actions.setHostList(data.hosts))
  } catch (error) {
    console.error(error)
  }
  yield put(actions.setIsLoading(false))
}

export function* getBlockedHostListApi() {
  yield put(actions.setIsLoading(true))
  try {
    const { data } = yield getBlockedHostListReq()
    yield put(actions.setBlockedHostList(data.blockedHosts))
  } catch (error) {
    console.error(error)
  }
  yield put(actions.setIsLoading(false))
}

export function* blockHostApi({ payload }: ReturnType<typeof actions.blockHost>) {
  yield put(actions.setIsLoading(true))
  try {
    yield blockHostReq(payload.phone, payload.reason)
    const { data } = yield getBlockedHostListReq()
    yield put(actions.setBlockedHostList(data.blockedHosts))
  } catch (error) {
    console.error(error)
  }
  yield put(actions.setIsLoading(false))
}

export function* watchHostApi() {
  yield takeLatest(actions.getHostList.type, getHostListApi)
  yield takeLatest(actions.getBlockedHostList.type, getBlockedHostListApi)
  yield takeLatest(actions.blockHost.type, blockHostApi)
}
